import React, { useState } from "react";
import "../styles/pushy.css";
import "../styles/hamburger.css";

const BODY_PUSHY_ACTIVE_CLASS = "pushy-active";
const HAMBURGER_ACTIVE_CLASS = "is-active";
const PUSHY_ACTIVE_CLASS = "pushy-opened";
const HAMBURGER_BLACK_CLASS = "black";

const Pushy: React.FC = () => {
  const [pushyState, setPushyState] = useState<boolean>(false);
  const [scrollPosition, setScrollPosition] = useState<number>(0);

  React.useEffect(() => {
    const handleScrollEvent = () => {
      setScrollPosition(window.scrollY || document.documentElement.scrollTop);
    };

    const closePushy = () => {
      setPushyState(false);
    };

    window.addEventListener("scroll", handleScrollEvent);
    const element = document.getElementById("pushy-overlay");
    element?.addEventListener("click", closePushy);

    if (pushyState) {
      document.body.classList.add(BODY_PUSHY_ACTIVE_CLASS);
    } else {
      document.body.classList.remove(BODY_PUSHY_ACTIVE_CLASS);
    }

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
      element?.removeEventListener("click", closePushy);
    };
  }, [pushyState]);

  const ShouldHamburgerBeBlack = () => {
    const slider = document.getElementById("slider");
    if (!slider) {
      return false;
    }
    return scrollPosition > slider.offsetHeight - 20;
  };

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const href = e.currentTarget.getAttribute("href");
    if (href) {
      const element = document.getElementById(href.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <header id="main-header">
        <div className={`pushy ${pushyState ? PUSHY_ACTIVE_CLASS : ""}`}>
          <nav>
            <ul className="pushy-ul text-center">
              <li className="pushy-item">
                <a
                  className="pushy-item-text"
                  href="#album"
                  onClick={scrollToSection}
                >
                  Works
                </a>
              </li>
              <li className="pushy-item">
                <a
                  className="pushy-item-text"
                  href="#about"
                  onClick={scrollToSection}
                >
                  About
                </a>
              </li>
              <li className="pushy-item">
                <a
                  className="pushy-item-text"
                  href="#contact"
                  onClick={scrollToSection}
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div
          className={`hamburger hamburger--spin ${
            pushyState ? HAMBURGER_ACTIVE_CLASS : ""
          }`}
          onClick={() => {
            setPushyState(!pushyState);
          }}
        >
          <div className="hamburger-box">
            <div
              className={`hamburger-inner ${
                ShouldHamburgerBeBlack() ? HAMBURGER_BLACK_CLASS : ""
              }`}
            ></div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Pushy;
